// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1j9h6","choiceBoxes":"toolbarselects_choiceBoxes__6VCA-","simpleField":"toolbarselects_simpleField__3pjgN"};